export default function Marquee({ items = [], className = "" }) {
  const doubled = [...items, ...items];
  return (
    <div className={`w-full overflow-hidden ${className}`} data-testid="editorial-marquee">
      <div className="marquee-track">
        {doubled.map((item, i) => (
          <span
            key={i}
            className="font-heading font-semibold uppercase tracking-widest text-sm px-6 flex items-center gap-6 text-[#AEBECD]"
          >
            {item}
            <span className="text-[#F26A21] text-base">●</span>
          </span>
        ))}
      </div>
    </div>
  );
}
